module.exports = __webpack_public_path__ + "static/media/restoration.b536f5ae.jpg";